<template>
  <div id="app">
    <el-container class="home-container">
      <el-header style="background-color: #000">
        <!-- 移动端菜单按钮（仅手机显示） -->
        <div class="mobile-menu-btn" @click="toggleMobileMenu">
          <span class="line"></span>
          <span class="line"></span>
          <span class="line"></span>
        </div>

        <div style="display: flex;background-color: #000;color: #fff; width: 100%;">
          <div class="navbar-brand" @click="shouye">
<!--            <img src="@/assets/img/logo.png" alt="加载中...">-->
<!--            {{ $t('navbar.home') }}-->
          </div>

          <!-- 独立的首页按钮（始终显示，不会被收入下拉菜单） -->
          <div class="home-menu-item" :class="{ active: isHomePage }" @click="handleHomeClick">
            {{ $t('navbar.home') }}
          </div>

          <!-- 导航栏（电脑端显示，手机端隐藏） -->
          <el-menu
              :default-active="activeMenu"
              class="el-menu-demo"
              mode="horizontal"
              background-color="#000"
              text-color="#fff"
              active-text-color="#409EFF"
              style="width: 100%;"
              @select="handleSelect"
          >
            <el-submenu index="productCenter" popper-class="product-center-menu">
              <template slot="title">{{ $t('navbar.productCenter') }}</template>
              <el-menu-item
                  v-for="(item, index) in productTypeList"
                  :key="index"
                  :index="`productCenter-${item.id || index}`"
                  @click="handleProductTypeClick(item)"
              >
                {{ item.name }}
              </el-menu-item>
            </el-submenu>
            <el-menu-item index="industryApplications">{{ $t('navbar.industryApplications') }}</el-menu-item>
            <el-menu-item index="newsEvents">{{ $t('navbar.newsEvents') }}</el-menu-item>
            <el-menu-item index="serviceRepair">{{ $t('navbar.serviceRepair') }}</el-menu-item>
            <el-menu-item index="aboutUs">{{ $t('navbar.aboutUs') }}</el-menu-item>
            <el-menu-item index="contactUS">{{ $t('navbar.contactUs') }}</el-menu-item>
            <el-menu-item index="shoppingMall">{{ $t('navbar.shoppingMall') }}</el-menu-item>
          </el-menu>

          <div style="width: 700px;display: flex;align-items: center; min-width: 337px;">
            <div class="geren-info geren-user" @click="orderManage">
              <img src="@/assets/img/gouwuche.png" alt="加载中..." width="20">
              <span class="geren-text">{{ $t('navbar.order') }}</span>
            </div>
            <div class="geren-info geren-user" @click="getUserInfo">
              <div v-if="userInfo != null && userInfo.nickname != null" class="geren-info-content">
                <img :src="$VUE_APP_BASE_API + userInfo.avatar" alt="加载中..." width="20">
                <span class="geren-text">{{ userInfo.nickname }}</span>
              </div>
              <div v-else class="geren-text-only">{{ $t('navbar.login') }}</div>
            </div>
            <div class="geren-info geren-user" @click="toggleLanguage">
              <span v-if="isChinese" class="geren-text">{{ $t('langSwitch.chinese') }}</span>
              <span v-else class="geren-text">{{ $t('langSwitch.english') }}</span>
            </div>
          </div>
        </div>

        <!-- 移动端导航菜单（仅手机显示） -->
        <div class="mobile-menu" v-if="showMobileMenu">
          <!-- 产品中心（带子菜单） -->
          <div class="mobile-menu-item mobile-menu-parent" @click="toggleProductCenterSubmenu">
            {{ $t('mobileMenu.productCenter') }}
            <span class="submenu-arrow" :class="{ 'submenu-arrow-open': showProductCenterSubmenu }">▼</span>
          </div>
          <!-- 产品中心子菜单 -->
          <div class="mobile-submenu" v-show="showProductCenterSubmenu">
            <div 
              class="mobile-menu-item mobile-submenu-item" 
              v-for="(item, index) in productTypeList" 
              :key="index"
              @click="handleMobileProductTypeClick(item)"
            >
              {{ item.name }}
            </div>
          </div>
          <div class="mobile-menu-item" @click="handleMobileSelect('industryApplications')">{{ $t('mobileMenu.industryApplications') }}</div>
          <div class="mobile-menu-item" @click="handleMobileSelect('newsEvents')">{{ $t('mobileMenu.newsEvents') }}</div>
          <div class="mobile-menu-item" @click="handleMobileSelect('serviceRepair')">{{ $t('mobileMenu.serviceRepair') }}</div>
          <div class="mobile-menu-item" @click="handleMobileSelect('aboutUs')">{{ $t('mobileMenu.aboutUs') }}</div>
          <div class="mobile-menu-item" @click="handleMobileSelect('contactUS')">{{ $t('mobileMenu.contactUs') }}</div>
          <div class="mobile-menu-item" @click="handleMobileSelect('shoppingMall')">{{ $t('mobileMenu.shoppingMall') }}</div>
        </div>
      </el-header>

      <div style="min-height: calc(100vh - 380px); background-color: #000">
        <el-main>
          <router-view/>
        </el-main>
      </div>

      <el-footer style="height: auto">
        <div class="carousel-container">
          <div class="fengexian"></div>
          <div
              style="width: 100%;max-width: 1165px;margin: auto;color: #fff;display: flex;flex-wrap: wrap; padding-top: 50px;">
            <div class="footer-info">
              <el-row>
                <el-col :span="24">
                  <div style="font-size:20px;font-weight: bold;margin-bottom: 20px">{{ $t('footer.innaChina') }}</div>
                </el-col>
                <el-col :span="12">
                  <div class="zitisize">{{ $t('footer.address') }}</div>
                </el-col>
                <el-col :span="12">
                  <div class="zitisize">{{ $t('footer.fax') }}</div>
                </el-col>
                <el-col :span="12">
                  <div class="zitisize">{{ $t('footer.phone') }}</div>
                </el-col>
                <el-col :span="12">
                  <div class="zitisize">{{ $t('footer.email') }}</div>
                </el-col>
              </el-row>
            </div>
            <div class="erweima-container">
              <div v-for="(item,index) in erweimaList" :key="index" class="erweima-item">
                <img :src="item.url" alt="加载中...">
                <div>{{ $t(item.titleKey) }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="carousel-container">
          <div class="fengexian"></div>
          <div style="width: 100%;max-width: 1165px;margin: auto;padding: 20px 0;">
            <div style="text-align: center;font-size: 14px;color: #666">
              <span>{{ $t('footer.copyright') }}</span>&nbsp;&nbsp;&nbsp;
              <img src="@/assets/gongan.png" height="14px" style="vertical-align: middle;"/>
              <span>{{ $t('footer.security') }}</span>
            </div>
          </div>
        </div>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import {getWechatLoginData} from "@/api/login";
import Cookies from "js-cookie";
import {getUserInfo} from "@/utils/auth";
import { mapActions, mapGetters } from 'vuex';
import {getProductTypeList} from "@/api/sysytem/homePage";

export default {
  name: 'layout',
  data() {
    return {
      activeMenu: undefined,
      visibleNumber: 6,
      topMenus: [
        {path: require('@/views/productCenter/index.vue'), title: '产品中心',},
        {path: require('@/views/industryApplications/index.vue'), title: '行业应用',},
        {path: require('@/views/newsEvents/index.vue'), title: '新闻活动',},
        {path: require('@/views/serviceRepair/index.vue'), title: '服务维修',},
        {path: require('@/views/aboutUs/index.vue'), title: '关于我们',},
        {path: require('@/views/shoppingMall/index.vue'), title: '商城',},
      ],
      erweimaList: [
        {url: require('@/assets/img/xcx.png'), titleKey: 'footer.miniProgram',},
        {url: require('@/assets/img/qywx.png'), titleKey: 'footer.enterpriseWeChat',},
      ],
      showMobileMenu: false, // 控制移动端菜单显示/隐藏
      showProductCenterSubmenu: false, // 控制产品中心子菜单展开/收起
      wechatState: "",
      userInfo: {},
      productTypeList: [], // 产品类型列表
    }
  },
  watch: {
    // 监听路由变化
    $route() {
      this.$nextTick(() => {
        this.activeMenu = '';
        this.showMobileMenu = false; // 路由变化时关闭移动端菜单
      })
    }
  },
  mounted() {
    if (this.$route.query.state) {
      console.log(this.$route.query.state)
      this.wechatState = this.$route.query.state;
      if (this.wechatState) {
        this.fetchWechatLoginData();
      }
    } else if(this.$route.query.message){
      this.$message.warning(this.$route.query.message)
    } else if (getUserInfo()) {
      console.log("用户信息：", getUserInfo())
      this.userInfo = getUserInfo()
    }
    // 获取产品类型列表
    this.getProductTypeList()
  },
  computed: {
    // 从Vuex获取全局语言状态（关键：确保状态统一）
    ...mapGetters(['getCurrentLanguage']),
    // 根据全局语言动态计算isChinese（不再依赖本地data，避免状态不一致）
    isChinese() {
      return this.getCurrentLanguage === 'zh-CN';
    },
    // 判断是否在首页
    isHomePage() {
      return this.$route.path === '/homePages' || this.$route.path === '/';
    }
  },
  methods: {
    ...mapActions(['changeLanguage']),
    toggleLanguage() {
      // 1. 计算目标语言（基于当前全局状态，而非本地isChinese）
      const targetLang = this.getCurrentLanguage === 'zh-CN' ? 'en-US' : 'zh-CN';

      // 2. 避免重复切换（如果点击时已是目标语言，不执行操作）
      if (targetLang === this.getCurrentLanguage) return;

      // 3. 同步更新Vuex全局状态（关键：让所有组件和axios拦截器感知变化）
      this.changeLanguage(targetLang);
      this.$store.dispatch('changeLanguage', targetLang);
      console.log("切换语言：", targetLang)
      // 4. 同步更新i18n语言（确保页面文本立即切换）
      this.$i18n.locale = targetLang;

      // 5. 持久化到localStorage（刷新页面后保持语言状态）
      localStorage.setItem('language', targetLang);

      // 6. （可选）URL携带语言参数（方便分享链接保留语言状态）
      this.$router.push({
        path: this.$route.path,
        query: { ...this.$route.query, lang: targetLang } // 保留原有参数，只更新lang
      }).catch(err => {
        // 忽略路由重复导航的错误
        if (err.name !== 'NavigationDuplicated') console.error(err);
      });

      // 7. （可选）添加切换提示
      location.reload()
    },
    async fetchWechatLoginData() {
      getWechatLoginData(this.wechatState).then(res => {
        if (res.code === 200) {
          let data = res.data.data;
          Cookies.set('token', data.token)
          Cookies.set('userInfo', data.userInfo)
          this.userInfo = JSON.parse(data.userInfo);
          this.$router.push("/");
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    handleSelect(key) {

      if (key && key.startsWith('productCenter-')) {
        return;
      }
      this.$router.push(`/${key}`).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error(err);
        }
      });
    },
    handleHomeClick() {
      this.activeMenu = 'homePages';
      this.$router.push('/homePages').catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          this.activeMenu = '';
          console.error(err);
        }
      });
    },
    shouye() {
      this.activeMenu = '1';
      this.$router.push('/homePages').catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          this.activeMenu = '';
          console.error(err);
        }
      });
    },
    // 我的
    getUserInfo() {
      this.activeMenu = '1';
      this.$router.push('/userInfo').catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error(err);
        }
      });
    },
    // 订单
    orderManage() {
      this.activeMenu = '1';
      this.$router.push('/orderTable').catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error(err);
        }
      });
    },
    // 移动端菜单控制
    toggleMobileMenu() {
      this.showMobileMenu = !this.showMobileMenu;
      // 关闭菜单时也关闭子菜单
      if (!this.showMobileMenu) {
        this.showProductCenterSubmenu = false;
      }
    },
    // 切换产品中心子菜单
    toggleProductCenterSubmenu() {
      this.showProductCenterSubmenu = !this.showProductCenterSubmenu;
    },
    // 移动端产品类型点击处理
    handleMobileProductTypeClick(item) {
      this.handleProductTypeClick(item);
      this.showMobileMenu = false; // 跳转后关闭菜单
      this.showProductCenterSubmenu = false; // 关闭子菜单
    },
    // 移动端菜单点击处理
    handleMobileSelect(key) {
      this.$router.push(`/${key}`).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error(err);
        }
      });
      this.showMobileMenu = false; // 跳转后关闭菜单
    },
    // 获取产品类型列表
    getProductTypeList() {
      getProductTypeList().then(res => {
        if (res && res.data) {
          this.productTypeList = res.data
        }
      }).catch(err => {
        console.error('获取产品类型列表失败:', err)
      })
    },
    // 处理产品类型点击
    handleProductTypeClick(item) {
      // 根据 typeId 跳转到不同页面
      // typeId = 1 或 2 时跳转到 productTypeDetail
      // typeId = 7 时跳转到 productAttachment
      // 其他跳转到 productTypeList
      const typeId = item.id;
      const typeIdNum = Number(typeId);
      let targetPath = '/productTypeList';

      if (typeIdNum === 1) {
        targetPath = '/productType/productTypeMilling';
      } else if (typeIdNum === 2) {
        targetPath = '/productTypeDetail';
      } else if (typeIdNum === 7) {
        targetPath = '/productAttachment';
      }

      this.$router.push({
        path: targetPath,
        query: { typeId: typeId, typeName: item.name }
      }).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error(err);
        }
      });
    }
  }
}
</script>

<style>
body {
  padding: 0;
  margin: 0;
}
</style>

<style scoped>
.home-container {
  width: 100%;
  overflow: hidden;
  position: relative;
}

.zitisize {
  font-size: 14px;
  color: #FFFFFF;
  opacity: 0.7;
  margin-bottom: 8px;
}

.carousel-container {
  position: relative;
  width: 100%;
  overflow: hidden;
  background-color: #000;
  padding-top: 50px;
}

/* 导航栏样式 */
.el-menu-demo {
  display: flex;
  align-items: center;
  padding: 0 20px;
  min-width: 550px;
}

.navbar-brand {
  margin-top: 15px;
  margin-left: 273px;
  margin-right: 11px;
  text-align: left;
  /*font-size: 20px;*/
  min-width: 70px;
  /*line-height: 60px*/
}

.navbar-brand:hover {
  cursor: pointer;
}

/* 独立的首页菜单项样式 */
.home-menu-item {
  display: flex;
  align-items: center;
  height: 60px;
  padding: 0 20px;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0; /* 防止被压缩 */
  transition: color 0.3s;
}

.home-menu-item:hover {
  color: #409EFF;
}

/* 当首页菜单项处于激活状态时 */
.home-menu-item.active {
  color: #409EFF;
}

.el-menu.el-menu--horizontal {
  border-bottom: solid 0px #3b82f6;
}

.el-header {
  padding: 0px;
  background-color: #000;
}

.el-card__body, .el-main {
  padding: 0px;
}

.el-footer {
  padding: 0px;
}

.geren-info {
  height: 17px;
  font-family: Noto Sans SC, Noto Sans SC;
  font-weight: 400;
  font-size: 14px;
  color: #FFFFFF;
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin-right: 30px;
  display: flex;
  align-items: center;
  transform: translateY(-3px); /* 向上移动3px */
}

.geren-info img {
  vertical-align: middle;
}

/* 统一文字样式 */
.geren-text {
  margin-left: 8px;
  display: inline-flex;
  align-items: center;
  height: auto;
  line-height: 1;
}

/* 只有文字的情况（登录） */
.geren-text-only {
  display: inline-flex;
  align-items: center;
  height: auto;
  line-height: 1;
}

/* 包含图片和文字的情况 */
.geren-info-content {
  display: flex;
  align-items: center;
}

.geren-user:hover {
  cursor: pointer;
}

.fengexian {
  width: 100%;
  max-width: 1165px;
  height: 0px;
  border: 1px solid #FFFFFF;
  opacity: 0.2;
  margin: auto
}

/* 移动端样式 - 仅在屏幕宽度≤1150px时生效 */
@media (max-width: 1150px) {
  div[style*="width: 700px;display: flex;align-items: center; min-width: 337px;"] {
    min-width: auto !important; /* 移除最小宽度限制 */
    margin-left: auto; /* 推到右侧 */
    padding-right: 50px; /* 给菜单按钮留出空间 */
  }

  /* 进一步减小用户信息项间距 */
  .geren-info {
    margin-right: 10px !important; /* 更小的右侧间距 */
    font-size: 14px;
  }

  /* 调整logo和用户区域的整体布局 */
  div[style*="display: flex;background-color: #000;color: #fff;"] {
    justify-content: space-between; /* 两端对齐 */
    width: 100%;
  }
  /* 隐藏电脑端导航 */
  .el-menu-demo {
    display: none;
  }

  /* 调整logo位置 */
  .navbar-brand {
    margin-right: 20px;
    margin-left: 30px;
  }

  /* 移动端首页菜单项样式 */
  .home-menu-item {
    padding: 0 15px;
    font-size: 14px;
  }

  /* 调整用户信息区域 */
  .geren-info {
    margin-right: 15px;
    font-size: 15px;
  }

  /* 移动端菜单按钮 */
  .mobile-menu-btn {
    position: absolute;
    top: 15px;
    right: 20px;
    width: 30px;
    height: 30px;
    z-index: 100;
    cursor: pointer;
  }

  .mobile-menu-btn .line {
    display: block;
    width: 100%;
    height: 2px;
    background-color: #fff;
    margin-bottom: 6px;
    transition: all 0.3s;
  }

  /* 移动端导航菜单 */
  .mobile-menu {
    position: absolute;
    top: 60px;
    left: 0;
    width: 100%;
    background-color: #000;
    z-index: 99;
    border-top: 1px solid rgba(255, 255, 255, 0.2);
  }

  .mobile-menu-item {
    padding: 15px 20px;
    color: #fff;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }

  .mobile-menu-item:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }

  /* 产品中心父菜单项样式 */
  .mobile-menu-parent {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
  }

  .submenu-arrow {
    font-size: 10px;
    transition: transform 0.3s;
    color: rgba(255, 255, 255, 0.6);
  }

  .submenu-arrow-open {
    transform: rotate(180deg);
  }

  /* 产品中心子菜单样式 */
  .mobile-submenu {
    background-color: rgba(0, 0, 0, 0.3);
    overflow: hidden;
  }

  .mobile-submenu-item {
    padding-left: 40px;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.8);
  }

  /* 页脚适配 */
  .footer-info {
    width: 100%;
    margin-bottom: 30px;
    padding-left: 20px;
  }

  .erweima-container {
    width: 100%;
    display: flex;
    justify-content: center;
    gap: 30px;
    padding-bottom: 20px;
  }

  .erweima-item {
    text-align: center;
  }

  .erweima-item img {
    width: 80px;
    height: 80px;
  }

  /* 调整主内容区高度 */
  div[style*="min-height: calc(100vh - 380px)"] {
    min-height: calc(100vh - 320px);
  }
}

/* 电脑端样式 - 屏幕宽度>1100px时生效（保持原有样式） */
@media (min-width: 1150px) {
  .mobile-menu-btn, .mobile-menu {
    display: none !important;
  }

  .erweima-container {
    display: flex;
    gap: 56px;
    text-align: center;
  }
}
</style>

<style>
.main-carousel .el-carousel__container {
  position: static !important;
  height: 500px;
}

/* 基础样式 - 仅保留底部边框且无背景 */
.el-input__inner {
  border: none !important;
  border-bottom: 1px solid #dcdfe6 !important;
  background-color: transparent !important;
  border-radius: 0 !important;
  padding-left: 35px !important;
  padding-right: 0 !important;
  box-shadow: none !important;
}

/* 聚焦状态样式 */
.el-input__inner:focus {
  border-bottom-color: #409eff !important;
  border-bottom-width: 1px !important;
}

/* 错误状态样式 */
.el-input.is-error .el-input__inner {
  border-bottom-color: #f56c6c !important;
}
</style>

<style>
/* 产品中心下拉菜单样式 */
.product-center-menu {
  background-color: #000 !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
}

.product-center-menu .el-menu-item {
  color: #fff !important;
  background-color: #000 !important;
}

.product-center-menu .el-menu-item:hover {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: #409EFF !important;
}

.product-center-menu .el-menu-item.is-active {
  background-color: rgba(64, 158, 255, 0.2) !important;
  color: #409EFF !important;
}

/* 隐藏产品中心菜单的小箭头 */
.el-menu-demo .el-submenu__icon-arrow {
  display: none !important;
}
</style>
